export const PID = 4
// 完整 appkey (在主后台查看 *必填)
export const APP_KEY = 'ea23085d8593ac36ae1a91226bcdb73b6abd00af4208569b138b965b34cf7687'
// 完整 app secret (在主后台查看 *必填)
export const APP_SECRET = '6b4dfe1443d51a3151d7be287d7f1eaf'
// 截取十六位的appkey 
export const APP_SPLIT_KEY = APP_KEY.slice(0,16)
// 截取十六位的appsecret
export const APP_SPLIT_SECRET = APP_SECRET.slice(0,16)
// 项目表前缀
export const TABLE_PREFIX = 'lefan'
